import { render, staticRenderFns } from "./TasksCompletedList.vue?vue&type=template&id=1b5543f0&scoped=true&"
import script from "./TasksCompletedList.vue?vue&type=script&lang=js&"
export * from "./TasksCompletedList.vue?vue&type=script&lang=js&"
import style0 from "./TasksCompletedList.vue?vue&type=style&index=0&id=1b5543f0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5543f0",
  null
  
)

export default component.exports